import { Component, OnInit } from '@angular/core';
import { PagerService } from 'src/app/Services/pager.service';
import { DatePipe } from '@angular/common';
import { MCPlanningMaterialService } from 'src/app/Services/MCPlanningMaterial/MCPlanningMaterial.service';
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { Documents } from '../../Models/AnnualRequirement/ExcelDocuments';
import { ViewChild } from '@angular/core';
import { FinalRequirementFilters } from 'src/app/Models/MCPlanningMaterial/mcplanningmaterial';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-additional-requirement',
  templateUrl: './additional-requirement.component.html',
  styleUrls: ['./additional-requirement.component.css'],
  providers: [PagerService, DatePipe]
})
export class AdditionalRequirementComponent implements OnInit {

  constructor(private mcPlanningMaterialService: MCPlanningMaterialService, private snackBar: MatSnackBarComponent,
    private _pagerService: PagerService, private datepipe: DatePipe, private router: Router,private toastr: ToastrService,) {

  }


  loader: string = 'none';
  files: File[] = [];
  fileName: string = '';
  document: Documents = new Documents();
  fileToUpload: File = null;
  details: any;
  pageSetting: number = 10;
  pager: any = {};
  model: any[];
  valid: any;
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;
  userName: string;
  date = new Date();
  currentDate: string;
  isFileCorrect: boolean;
  roleID: string;
  selectedMonth: any = '';
  selectedJobType: any = '';
  selectedBrand: any = '';
  selectedCrop: any = '';
  selectedstate: any = '';
  selectedyear: any = '';
  accessdata:string='';// add by deepanshu 4 june 2023

  @ViewChild('file') input;
  @ViewChild('brand') brand;
  @ViewChild('crop') crop;
  @ViewChild('jobtype') jobtype;
  @ViewChild('month') month;
  @ViewChild('state') state;
  @ViewChild('year') year;

  public brandSettings = {};
  public cropSettings = {};
  public jobTypeSettings = {};
  public monthSettings = {};
  public stateSettings = {};
  public yearSettings = {};
  monthDropdown = [];

  additionalRequirementFilters: FinalRequirementFilters = new FinalRequirementFilters();
  dropdownList = [
    { item_id: '1', item_text: 'Jan' },
    { item_id: '2', item_text: 'Feb' },
    { item_id: '3', item_text: 'Mar' },
    { item_id: '4', item_text: 'Apr' },
    { item_id: '5', item_text: 'May' },
    { item_id: '6', item_text: 'Jun' },
    { item_id: '7', item_text: 'Jul' },
    { item_id: '8', item_text: 'Aug' },
    { item_id: '9', item_text: 'Sep' },
    { item_id: '10', item_text: 'Oct' },
    { item_id: '11', item_text: 'Nov' },
    { item_id: '12', item_text: 'Dec' }
  ];
  ascNumberSort: boolean = true;
  sortDirection: string = '';

  ngOnInit(): void {
    this.getAdditionalRequirementFilters();
    this.mcPlanningMaterialService.GetAdditionalRequirementDetail('', '', '', '','','')
      .subscribe((resData: any) => {
        if (resData.status == true) {
          // this.snackBar.openSnackBar(resData.message, 'Close', 'green-snackbar');
          this.details = resData.data;
          this.model = resData.data;
          this.ascNumberSort = true;
          this.sortDirection = '';
          if (sessionStorage.tabID == undefined) {
            this.router.navigate(['/MCMaterial/Login']);
          }
          // this.setPage(1,this.pageSetting)
          this.loader = 'none';
        } else {
          this.toastr.error(resData.message);
          //this.snackBar.openSnackBar(resData.message, 'Close', 'red-snackbar');
          this.loader = 'none';
        }
      });

    //this.getAdditionalRequirementDetails();
    this.selectedPaging = '0';
    this.roleID = localStorage.getItem('mcmt_roleID');
    this.monthDropdown = [
      { "id": 1, "itemName": "January" },
      { "id": 2, "itemName": "February" },
      { "id": 3, "itemName": "March" },
      { "id": 4, "itemName": "April" },
      { "id": 5, "itemName": "May" },
      { "id": 6, "itemName": "June" },
      { "id": 7, "itemName": "July" },
      { "id": 8, "itemName": "August" },
      { "id": 9, "itemName": "September" },
      { "id": 10, "itemName": "October" },
      { "id": 11, "itemName": "November" },
      { "id": 12, "itemName": "December" }
    ];
    this.brandSetting();
    this.cropSetting();
    this.jobTypeSetting();
    this.monthSetting();
    this.stateSetting();
    this.yearSetting();
  }

  download() {
    //if (this.roleID == '39' || this.roleID == '44' || this.roleID == '43') {
      if (this.roleID == '39' || this.roleID == '44' || this.roleID == '43' || this.roleID == '77' || this.roleID == '47' || this.roleID == '28') {
      if (this.state.selectedItems == '') {
        this.toastr.error("Please Select Region");
        //this.snackBar.openSnackBar("Please Select Region", 'Close', 'red-snackbar');
        return;
      }
    }
    this.loader = 'block';
    this.loader = 'block';
    let selectedBrand = '';
    let selectedCrop = '';
    let selectedJobtype = '';
    let selectedMonth = '';
    let selectedState = '';
    let selectedYear = '';
    this.loader = 'block';
    selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    selectedMonth = Array.prototype.map.call(this.month.selectedItems, function (item) { return item.id; }).join(",");
    selectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
    selectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
    if ((this.roleID != '42') && (this.roleID != '76')) {
      selectedState = Array.prototype.map.call(this.state.selectedItems, function (item) { return item.id; }).join(",");
    }
    else {
      selectedState = '';
    }
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    this.mcPlanningMaterialService.downloadAdditionalRequirementExcel(selectedBrand, selectedMonth, selectedCrop, selectedJobtype, selectedState,selectedYear)
      .subscribe(
        success => {
          var date = new Date();
          debugger;
          let latest_date = this.datepipe.transform(date, 'dd-MMM-yy')
          let name = localStorage.getItem('mcmt_userName').split(' ');
          let firstname = name[0];
          let lastName = name[1];
          //let roleId=localStorage.getItem('mcmt_roleID');
          let cYear = this.year.selectedItems[0].id;
          let excelName = firstname + '_' + lastName + '_'+ cYear + '_AdditionalRequirement_' + latest_date + '.xlsx';
          saveAs(success, excelName);

          this.loader = 'none';
        },
        err => {
          if (this.roleID == '42'|| this.roleID == '76') {
            this.toastr.error("No Data Available.");
            //this.snackBar.openSnackBar("No Data Available.", 'Close', 'red-snackbar');
          }
          else {
            this.toastr.error("No Data Available.Select Region filter to download NO-RMH or No-ZMH or No-DMH Excel");
            //this.snackBar.openSnackBar("No Data Available.Select Region filter to download NO-RMH or No-ZMH or No-DMH Excel", 'Close', 'red-snackbar');
          }
          this.loader = 'none';
          console.log(err);
        }
      );
  }
  getAdditionalRequirementDetails() {
    this.loader = 'block';
    let selectedBrand = '';
    let selectedCrop = '';
    let selectedJobtype = '';
    let selectedMonth = '';
    let selectedYear = '';
    let selectedState = '';
    this.loader = 'block';
    selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    selectedMonth = Array.prototype.map.call(this.month.selectedItems, function (item) { return item.id; }).join(",");
    selectedCrop = Array.prototype.map.call(this.crop.selectedItems, function (item) { return item.id; }).join(",");
    selectedJobtype = Array.prototype.map.call(this.jobtype.selectedItems, function (item) { return item.id; }).join(",");
    selectedYear = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    if (this.roleID != '42' && this.roleID != '76') {
      selectedState = Array.prototype.map.call(this.state.selectedItems, function (item) { return item.id; }).join(",");
    }
    else {
      selectedState = '';
    }
    this.mcPlanningMaterialService.GetAdditionalRequirementDetail(selectedJobtype, selectedBrand, selectedCrop,
      selectedMonth,selectedYear,selectedState)
      .subscribe((resData: any) => {
        if (resData.status == true) {
          // this.snackBar.openSnackBar(resData.message, 'Close', 'green-snackbar');
          this.details = resData.data;
          this.model = resData.data;
          //this.setPage(1,this.pageSetting)
          this.loader = 'none';
        } else {
          //this.snackBar.openSnackBar(resData.message, 'Close', 'red-snackbar');
          this.toastr.error(resData.message);
          this.loader = 'none';
        }
      });
  }
  downloadLink(fileName: string): void {
    let url: string = '/Templates/' + fileName;
    this.mcPlanningMaterialService.downloadFile(fileName, url);
  }

  getAdditionalRequirementFilters() {
    this.loader = 'block';
    this.mcPlanningMaterialService.getAdditionalRequirementFilters()
      .subscribe((resData: any) => {
        if (resData.status == true) {
          debugger;
          this.additionalRequirementFilters = resData.data;
          this.accessdata=resData.data.access[0].access; //add by deepanshu 4 june
          //alert(this.accessdata);//add by deepanshu 4 june
          this.onCurrentRequirementYearSelected(this.additionalRequirementFilters.year)
          this.loader = 'none';
        }
        else {
          //this.snackBar.openSnackBar(resData.msg, 'Close', 'red-snackbar');
          this.toastr.error(resData.msg);
          this.loader = 'none';
        }
      }
      );
  }

  public onCurrentRequirementYearSelected(item: any) {
    class YearItemList{
      id: number;
      text: string;
  }
    let requiredItem: YearItemList[] = [];
    var obj = {
      id : (new Date()).getFullYear(),
      text: (new Date()).getFullYear().toString()
    }
    requiredItem.push(obj)
    this.year.selectedItems=requiredItem
    this.yearSetting();
  }

  onYearSelect(item: any) {
    let selectedyear = this.year.selectedItems[0].id;
    
    if(selectedyear != (new Date()).getFullYear().toString())
    {     
      var someElement= document.getElementById("ancUploadExcel"); 
      someElement.className += "hideuploadExcel";
    }
    else
    {
      document.getElementById("ancUploadExcel").classList.remove("hideuploadExcel");
    }
  }


  filter() {
    this.getAdditionalRequirementDetails();
  }

  filesDroppedAdd(files: File[]) {
    this.loader = 'block';
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    // let name =localStorage.getItem('mcmt_userName').split(' ');
    //   let firstname=name[0];
    //   let lastName=name[1];
    // let correctFileName=firstname+'_'+lastName+'_AdditionalRequirement_'

    // if(fileNameParts[0].includes(correctFileName)){
    //   this.isFileCorrect=true;
    // }
    // else{
    //   this.isFileCorrect=false;
    // }
    // if(this.isFileCorrect==false)
    // {
    //   this.snackBar.openSnackBar('Please Select Valid File.','Close','red-snackbar');
    //   this.input.nativeElement.value = null;
    //   this.loader = 'none';
    //   return false;

    // }
    if (fileType != 'xls' && fileType != 'xlsx') {
      this.toastr.error('Please Select Valid File Type.');
      //this.snackBar.openSnackBar('Please Select Valid File Type.', 'Close', 'red-snackbar');
      this.input.nativeElement.value = null;
      this.loader = 'none';
      return false;

    }

    this.loader = 'block';
    this.document.file = <File>this.files[0];
    //this.document.UploadedBy = localStorage.getItem('userId');
    this.mcPlanningMaterialService.uploadAdditionalRequirement(this.document.file)
    
      .subscribe((resData: any) => {
        if (resData.status == true) {
          this.toastr.success(resData.message);
          //this.snackBar.openSnackBar(resData.message, 'Close', 'green-snackbar');
          // this.getAdditionalRequirementDetails();

          this.getAdditionalRequirementDetails();
        } else {
          this.toastr.error(resData.message);
          //this.snackBar.openSnackBar(resData.message, 'Close', 'red-snackbar');

          this.getAdditionalRequirementDetails();
        }
        // this.getDocuments();
        // this.displayUpload = 'none';
        this.files = [];
        this.input.nativeElement.value = null;
        this.loader = 'none';
      });
    this.files = files;
    this.fileName = files[0].name;
  }
  getbrandWiseData(filter: any) {
    this.loader = 'block';
    let selectedBrand = '';
    selectedBrand = Array.prototype.map.call(this.brand.selectedItems, function (item) { return item.id; }).join(",");
    this.mcPlanningMaterialService.getdataonbrandselection(selectedBrand, '', '')
      .subscribe((response) => {
        if (response.status) {


          this.brand.selectedItems = response.data.brands.map(item => { return { id: item.brandID, text: item.brandName } });
          this.crop.selectedItems = response.data.crops.map(item => { return { id: item.cropID, text: item.cropName } });
          this.jobtype.selectedItems = response.data.jobTypes.map(item => { return { id: item.jobTypeID, text: item.jobTypeName } });
          this.loader = 'none';
        }


      }, error => {
        console.log(error);
        this.loader = 'none';
      });
  }
  brandSetting() {
    this.brandSettings = {
      singleSelection: false,
      idField: 'brandID',
      textField: 'brandName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Brand Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  cropSetting() {
    this.cropSettings = {
      singleSelection: false,
      idField: 'cropID',
      textField: 'cropName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Crop Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  jobTypeSetting() {
    this.jobTypeSettings = {
      singleSelection: false,
      idField: 'jobTypeID',
      textField: 'jobTypeName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No JobType Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  monthSetting() {
    this.monthSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Month Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  stateSetting() {
    this.stateSettings = {
      singleSelection: false,
      idField: 'stateID',
      textField: 'stateName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Region Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };   
  }
  yearSetting() {
    this.yearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  onbrandSelectAll(item: any) {
    this.getbrandWiseData(this.brand.selectedItems);
  }
  onbrandSelect(item: any) {
    this.getbrandWiseData(this.brand.selectedItems);
  }
  onbrandDeSelect(item: any) {
    if (this.brand.selectedItems < 1) {
      this.crop.selectedItems = [];
      this.jobtype.selectedItems = [];
    }
    else
      this.getbrandWiseData(this.brand.selectedItems);
  }
  onbrandDeSelectAll(item: any) {
    this.crop.selectedItems = [];
    this.jobtype.selectedItems = [];
    this.brand.selectedItems = [];
  }
  sort() {
    let sortedArray: any[] = [];
    let splitString: any[] = [];
    if (this.ascNumberSort == true) {
      this.dropdownList.forEach(x => {
        this.details.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = false;
      this.sortDirection = 'asc';
      this.details = sortedArray;
    }
    else {
      this.dropdownList.forEach(x => {
        this.details.forEach(element => {
          splitString = element.requirementMonth.split("'");
          if (x.item_text == splitString[0]) {
            sortedArray.push(element);
          }
        })
      })
      this.ascNumberSort = true;
      this.sortDirection = 'desc';
      this.details = sortedArray.reverse();
    }
  }

  ConvertToCurrency(value:any)
  {
    let parts = Intl.NumberFormat('en-IN');
    return parts.format(parseInt(value.replace(',','')));
  }
}



